import axios from 'axios'
import {message} from 'antd';
import i18 from "../i18";

if(process.env.REACT_APP_SERVER_URL){
    axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
}

axios.interceptors.response.use(res=> {
    if(res){
        const {data:{statusCode = 200,message: str} = {statusCode:200, message:""}} = res || {}
        if(statusCode !== 200){
            if(str)
                message.error(str)
            else
                message.error(`Failed with status ${statusCode}`)
        }
    }
    return res;
}, err=>{
    if (err.response){
        if ( err.response.status === 422 ) {
            console.log(err.message + Object.values(err.response.data.errors))
            message.error(Object.values(err.response.data.errors));
        } else  if (err.response.status === 400) {
            message.error(err.message + " - " + err.response.data.data.message);
        } else {
            message.error(err.message);
        }
    } else {
        message.error(err.message);
    }
});

export const fc_config = async (token: string)=>{
    return axios.get(`/fc/${token}`)
}

export const getFeConfig = async (id: string)=>{
    return await axios.get(`/api/fc/config/${id}`)
}

export const getFeData = async (id: string)=>{
    return await axios.get(`/api/fc/data/${id}`)
}

export const submitFCConfirmation = async (data: {[key:string]:any})=>{
    return await axios.post(`/api/confirmation`, data);
}

export const submitFCRefusal = async (data: {[key:string]:any})=>{
    return await axios.post(`/api/refusal`, data);
}

export const fetchConsent = async (schema:string, name:string)=>{
    return axios.get(`/api/consent-document/${schema}/${name}`)
}

export const fetchGDPR = async ()=>{
    const {data} = await axios({
        url: `/api/visualize/gdpr`,
        params:{
            language: i18.language
        },
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    window.open(url, `GDPR Consent`, params)
}

export const validateFcId = async (data: any)=> {
    return axios.post(`/api/fcIdValidation`, data);
}

export const validateCompanyVAT = async (data: any)=> {
    return axios.post('/api/fcCompanyVATValidation', data);
}

export const getConfirmationInfo = async ()=>{
    return await axios.get(`/api/getConfirmationInfo`);
}